import { LABORATORIUM_PARAMETER } from '../actionTypes'

const initialState = {
  data: [],
  total: 0,
  params: { limit: 10, offset: 0, q: '' },
  loading: false,
  error: null,
  success: null
}

const laboratoriumParameterReducer = (state = initialState, action) => {
  switch (action.type) {
    case LABORATORIUM_PARAMETER.LIST_REQUEST:
      return Object.assign({}, state, { loading: true, error: null })

    case LABORATORIUM_PARAMETER.LIST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        data: action.data,
        total: action.total,
        params: action.params || {},
        error: null
      })

    case LABORATORIUM_PARAMETER.LIST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        data: [],
        total: 0,
        error: action.error || 'Failed to load data'
      })

    case LABORATORIUM_PARAMETER.CREATE_REQUEST:
    case LABORATORIUM_PARAMETER.UPDATE_REQUEST:
    case LABORATORIUM_PARAMETER.DELETE_REQUEST:
      return Object.assign({}, state, {
        loading: true,
        error: null,
        success: null
      })

    case LABORATORIUM_PARAMETER.CREATE_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        data: [action.data].concat(state.data),
        total: state.total + 1,
        success: 'Successfully created',
        error: null
      })

    case LABORATORIUM_PARAMETER.UPDATE_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        data: state.data.map((item) => {
          const itemId = String(item.id ?? item.uuid ?? '')
          return itemId === String(action.data?.id ?? action.data?.uuid ?? '') ? action.data : item
        }),
        success: 'Successfully updated',
        error: null
      })

    case LABORATORIUM_PARAMETER.DELETE_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        data: state.data.filter((item) => String(item.id ?? item.uuid ?? '') !== String(action.id)),
        total: Math.max(0, state.total - 1),
        success: 'Successfully deleted',
        error: null
      })

    case LABORATORIUM_PARAMETER.CREATE_FAILURE:
    case LABORATORIUM_PARAMETER.UPDATE_FAILURE:
    case LABORATORIUM_PARAMETER.DELETE_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        error: action.error,
        success: null
      })

    case LABORATORIUM_PARAMETER.CLEAR_NOTIFY:
      return Object.assign({}, state, {
        error: null,
        success: null
      })

    default:
      return state
  }
}

export default laboratoriumParameterReducer
